import { useContext, useMemo } from 'react';
import { StyledStoryWithQuestionsActivity } from './StoryWithQuestionsActivity.styled';
import useStoryWithQuestionsActivity from './useStoryWithQuestionsActivity.hook';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import StoryWithQuestions from './StoryWithQuestions/StoryWithQuestions';
import CoverMenu from './components/CoverMenu/CoverMenu';
import { GameControlBar } from '../GameActivity/GameControlBar/GameControlBar';
import AudioAutoPlayer from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayer';

export default function StoryWithQuestionsActivity({
  activity,
  activityConf,
  taskProgressActions,
  // initialTaskProgress,
  // isTaskActivityDone,
  // demoMode,
}) {
  const fullscreenContext = useContext(FullscreenContext);

  const { state, actions } = useStoryWithQuestionsActivity({
    activity,
    activityConf,
  });

  const coverImageSrc = `${process.env.NEXT_PUBLIC_AWS_CLOUDFRONT_HOST}/${
    activity.data.cover || `${activity.data.folder}/imgs/cover.webp`
  }`;

  const pages = useMemo(
    () =>
      activity.data.pages
        ?.filter(
          (page) =>
            page.type == 'img' ||
            page.type == 'text' ||
            state.activityConf?.miniactivityType != 'story'
        )
        .map((page, pageIndex) => ({
          ...page,
          id: pageIndex + 1,
        })) || [],
    [activity.data.pages, state.activityConf?.miniactivityType]
  );

  return (
    <StyledStoryWithQuestionsActivity
      className={fullscreenContext.state.isFullscreen ? 'fullscreen' : ''}
    >
      <div className="main-content">
        {
          {
            COVER: (
              <CoverMenu
                activity={activity}
                activityConf={state.activityConf}
                isTask={!!taskProgressActions}
                coverImageSrc={coverImageSrc}
                gameActions={{
                  setGameConf: actions.setActivityConf,
                  startGame: actions.startGame,
                }}
              />
            ),
            GAME: state.activityConf && (
              <StoryWithQuestions
                coverImageSrc={coverImageSrc}
                activity={activity}
                activityConf={state.activityConf}
                pages={pages}
                taskProgressActions={taskProgressActions}
                setCurrentPage={actions.setCurrentPage}
              />
            ),
          }[state.screen]
        }
      </div>
      <GameControlBar
        state={state}
        actions={actions}
        activityConf={activityConf}
      >
        {state.currentPage ? (
          <div className="controls">
            <div className="page-counter">
              {state.currentPage.id}/{pages.length}
            </div>
          </div>
        ) : null}
      </GameControlBar>
      <AudioAutoPlayer />
    </StyledStoryWithQuestionsActivity>
  );
}
